<template>
  <q-page class="container" padding>
    <PageHeader
      title="Cadastrar Cliente"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div>
      <q-form ref="myForm" @submit.prevent="onSubmit">
        <div class="row col-12 q-col-gutter-sm">
          <div class="col-md-3 col-sm-12 col-xs-12">
            <div class="text-brand-5 text-weight-bold">Cliente ID</div>
            <q-input
              dense
              outlined
              v-model="cliente.clienteId"
              :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
            >
            </q-input>
          </div>

          <div>
            <p></p>
            <q-btn
              no-caps
              class="q-mt-sm full-width"
              color="positive"
              label="Criar"
              type="submit"
              icon="add"
              @click="criar()"
            />
          </div>
        </div>
      </q-form>
    </div>

    <div class="q-mt-md">
      <div class="q-pt-md">
        <div class="row items-center justify-between q-mb-md">
          <div class="text-brand-5 text-weight-bold text-h6">
            Listagem de Clientes
          </div>
          <q-btn
            no-caps
            color="info"
            label="Monitoramento NATS"
            icon="monitor"
            @click="abrirModalNats"
            class="q-ml-md"
          >
            <q-tooltip>Visualizar filas do NATS</q-tooltip>
          </q-btn>
        </div>
        <q-table
          table-header-class="bg-accent text-weight-bold"
          id="customers"
          :rows="listaClientes"
          :columns="columns"
          dense
          @request="atualizarTabela"
          :loading="loading"
          :filter="filter"
          class="tabela-tamanho-fixo"
          row-key="clinteId"
          flat
          :rows-per-page-options="[0]"
        >
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td class="text-left" key="clienteId" :props="props">{{
                props.row.clienteId
              }}</q-td>
              <q-td class="text-left" key="ativo" :props="props">
                <div
                  v-if="props.row.ativo == true"
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #e8ffec;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-positive" />
                  <div
                    style="width: fit-content"
                    class="text-bold text-brand-5"
                  >
                    {{ "Sim" }}
                  </div>
                </div>
                <div
                  v-else
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #ffe9e9;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-red" />
                  <div
                    style="width: fit-content; color: #850202"
                    class="text-bold"
                  >
                    {{ "Não" }}
                  </div>
                </div>
              </q-td>
              <q-td class="text-right">
                <router-link
                  :to="{
                    name: 'detalheCliente',
                    params: { clienteId: props.row.clienteId },
                  }"
                >
                  <q-btn color="blue-6" round icon="edit" size="sm" />
                </router-link>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>

    <!-- Modal de Monitoramento NATS -->
    <ModalMonitoramentoNats v-model="showModalNats" />
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ModalMonitoramentoNats from "../components/ModalMonitoramentoNats.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  name: "CriarCliente",
  components: {
    ModalMonitoramentoNats,
    PageHeader,
  },
  setup() {
    const router = useRouter();
    const $q = useQuasar();
    const myForm = ref(null);
    const cliente = ref({
      clienteId: "",
    });

    const loading = ref(true);
    const listaClientes = ref([]);
    const showModalNats = ref(false);

    const columns = [
      {
        name: "clienteId",
        label: "ID",
        field: "clienteId",
        align: "left",
        sortable: true,
      },
      { name: "ativo", label: "Ativo", field: "ativo", align: "left" },
      {
        name: "",
        label: "Editar",
        field: "",
        align: "right",
      },
    ];

    const store = useStore();

    let listarClientes = async () => {
      try {
        let resposta = await store.dispatch("office/listarCliente");

        listaClientes.value = resposta.listaClientes;

        loading.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    const consultar = async (clienteId) => {
      router.push({ name: "detalheCliente", params: { clienteId } });
    };

    onMounted(() => {
      listarClientes();
    });

    let criar = async () => {
      let sucess = await myForm.value.validate();
      if (!sucess) {
        return;
      }

      try {
        await store.dispatch("office/criarCliente", {
          clienteId: cliente.value.clienteId,
        });

        $q.notify({
          message: "Cliente Cadastrado!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        onReset();
        listarClientes();
      } catch (e) {
        $q.notify({
          message: e.response.data.erro.detalhes[0].clienteId,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      cliente.value = {};
    };

    const abrirModalNats = () => {
      showModalNats.value = true;
    };

    return {
      cliente,
      criar,
      myForm,
      options: ["SIM", "NÃO"],
      columns,
      listaClientes,
      filter: ref(""),
      consultar,
      showModalNats,
      abrirModalNats,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
</style>
